import { P2Alert, P2TextDescription } from 'react-bootstrap-common-script';
import { Separator } from '../separator';
import '../../styles/pages/application-coo-stage-d/proposed-financial-plan.scss';
import { StageDCurrentFinancialPlan } from '../../models/classes/stage-d/Review-Application.class';
import { Helpers } from '../../utils/helper';

interface PaymentRequiredSectionInterface {
  currentFinancialPlanData?: StageDCurrentFinancialPlan;
}

const PaymentRequiredSection = ({ currentFinancialPlanData }: PaymentRequiredSectionInterface) => {
  const totalPaymentRequired = currentFinancialPlanData?.total_payment_required ?? 0;
  const totalSolicitorFeeByCash = currentFinancialPlanData?.total_solicitor_fee_by_cash ?? 0;

  return (
    <div>
      <P2TextDescription
        color='#000'
        title={'Payment Required'}
        description="All fees must be paid at your completion appointment. You can pay using cash, AXS, PayNow, direct debit or Cashier's Order. Standard payment limits will apply."
      />
      <div className='polymer-stage-d-financial-plan-table'>
        <div className='polymer-stage-d-financial-plan-table__header-row'>
          <p>Payment Required</p>
          <p>{Helpers.amountToTwoDecimals(totalPaymentRequired)}</p>
        </div>
        <Separator variant='solid' />

        <div className='polymer-stage-d-financial-plan-table__primary-row polymer-stage-d-financial-plan-table__primary-row_resale-levy'>
          <p>Resale Levy</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.resale_levy)}</p>
        </div>

        <div className='polymer-stage-d-financial-plan-table__primary-row'>
          <p>Stamp Fees</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Seller Stamp Duty</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.seller_stamp_duty)}</p>
        </div>

        <div className='polymer-stage-d-financial-plan-table__primary-row'>
          <p>Conveyancing Fees</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Transfer</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.conveyancing_fees.byCashTransfer)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Total Discharge of Mortgage</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.conveyancing_fees.byCashTDM)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Miscellaneous</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.conveyancing_fees.byCashMiscellaneous)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Notice of Death</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.conveyancing_fees.byCashNoticeOfDeath)}</p>
        </div>

        <div className='polymer-stage-d-financial-plan-table__primary-row'>
          <p>Registration Fees</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Total Discharge of Mortgage</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.property_registration_fees.byCashTdm)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Notice of Death</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.property_registration_fees.byCashNoticeOfDeath)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Registrar</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.property_registration_fees.byCashRegistrar)}</p>
        </div>

        <div className='polymer-stage-d-financial-plan-table__primary-row'>
          <p>Others</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Outstanding Late Payment Charges</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.outstanding_late_payment_charge)}</p>
        </div>
        <div className='polymer-stage-d-financial-plan-table__sub-row'>
          <p>Fire Insurance - Outstanding Premium & Admin Fee</p>
          <p>{Helpers.amountToTwoDecimals(currentFinancialPlanData?.outstanding_fi_premium_and_admin_fee)}</p>
        </div>
        {currentFinancialPlanData?.others_fee.map((fee) => {
          return (
            <div className='polymer-stage-d-financial-plan-table__sub-row'>
              <p>{fee.fee_name}</p>
              <p>{Helpers.amountToTwoDecimals(fee.amount)}</p>
            </div>
          );
        })}
      </div>
      <div className='polymer-stage-d-financial-plan-container__content-text'>
        <P2TextDescription color='#333' description={'* All amounts stated are inclusive of GST.'} />
      </div>

      {/* Batch-2 */}
      {totalSolicitorFeeByCash > 0 && (
        <>
          <div className={'polymer-current-owner-financial-plan-top-section-container__info-box pt-4 mb-4'}>
            <P2Alert
              withBorder
              variant={'info'}
              title={`Total payment required is ${Helpers.amountToTwoDecimals(totalPaymentRequired + totalSolicitorFeeByCash)}`}
              text={`Total payment required will include payment by owner as shown above and payment by private lawyer of ${Helpers.amountToTwoDecimals(
                totalSolicitorFeeByCash
              )}`}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentRequiredSection;
